// extracted by mini-css-extract-plugin
module.exports = {"root":"root-2_fii","icon":"icon-2c0eq"};